import { lazy } from "react"
const ListAnagrafica = lazy(() => import('../../views/pages/anagrafica/ListAnagrafica'))

const AnagraficaRoutes = [
    {
        element: <ListAnagrafica />,
        path: '/lista-anagrafica'
    }
]
export default AnagraficaRoutes